import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "result-list"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionListEntry = _resolveComponent("RegionListEntry")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.regions && _ctx.regions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
            return (_openBlock(), _createElementBlock("div", {
              key: region.id,
              class: ""
            }, [
              _createVNode(_component_RegionListEntry, {
                region: region,
                showCoursesButton: true
              }, null, 8, ["region"]),
              _hoisted_2
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}